/**
 * Deploy-specific configuration whitelists.
 *
 * The room-join timing switches may be overridden per link
 * (#config.vrsPrestartJoin=false), so the old and new join can be compared on
 * one machine without changing config.js for everyone.
 */
export default [
    'vrsJoinGraceAfterSignalingMs',
    'vrsPrestartJoin'
];
